import Request from "./index";

export type SupplierCustomerStatus =
  | "ACTIVE"
  | "NEW"
  | "INACTIVE";

export type SupplierCustomerPayload = {
  name: string;
  business_number: string;
  contact_name?: string;
  phone?: string;
  email?: string;
  address?: string;
  status?: SupplierCustomerStatus;
};

export const getSupplierCustomers = (
  search = "",
  status = ""
) => {
  const params = new URLSearchParams();

  if (search) {
    params.set("search", search);
  }

  if (status) {
    params.set("status", status);
  }

  const query = params.toString();

  return Request.get(
    `supplier/customers/${query ? `?${query}` : ""}`
  );
};

export const getSupplierCustomer = (id: number) =>
  Request.get(`supplier/customers/${id}/`);

export const createSupplierCustomer = (
  data: SupplierCustomerPayload
) =>
  Request.post("supplier/customers/", data);

export const updateSupplierCustomer = (
  id: number,
  data: Partial<SupplierCustomerPayload>
) =>
  Request.patch(`supplier/customers/${id}/`, data);

export const deleteSupplierCustomer = (id: number) =>
  Request.remove(`supplier/customers/${id}/`);

export const createSupplierCustomerContact = (
  customerId: number,
  data: Object
) =>
  Request.post(
    `supplier/customers/${customerId}/contacts/`,
    data
  );

export const updateSupplierCustomerContact = (
  contactId: number,
  data: Object
) =>
  Request.patch(
    `supplier/customer-contacts/${contactId}/`,
    data
  );

export const deleteSupplierCustomerContact = (
  contactId: number
) =>
  Request.remove(
    `supplier/customer-contacts/${contactId}/`
  );

export const createSupplierCustomerSite = (
  customerId: number,
  data: Object
) =>
  Request.post(
    `supplier/customers/${customerId}/sites/`,
    data
  );

export const updateSupplierCustomerSite = (
  siteId: number,
  data: Object
) =>
  Request.patch(
    `supplier/customer-sites/${siteId}/`,
    data
  );

export const deleteSupplierCustomerSite = (
  siteId: number
) =>
  Request.remove(
    `supplier/customer-sites/${siteId}/`
  );